<template>
  <div>
    <el-pagination layout="prev, pager, next" :total="total" @current-change="(e) => $emit('change', e)"> </el-pagination>
  </div>
</template>

<script>
export default {
    props: ['total', 'pageSize', 'pageCount']
};
</script>

<style>
</style>